module.exports = __webpack_public_path__ + "static/ogimg-planetcross-1a6c7bfa115a5bfe4383d4ca8cf8de9e.jpg";